import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Page from '../components/Page';
import { useTheme } from '@mui/material/styles';

const General = () => {
  const theme = useTheme();

  return (
    <Page>
      <Box>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          <Box>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              PARENT ORIENTATION AND TEACHER INTRODUCTION
            </Typography>
            <Typography align="justify" paragraph>
              The academic year 2021-22 saw new beginnings at National Public
              School, Yeshwanthpur, with extensive sessions of Parent
              Orientation conducted for all Classes from Mont-KG to Class-12.
              While the sessions for Classes 10 and 12 were held on 9 and 10
              April, respectively, those for the others were held from 22 May to
              31 May, concluding with sessions for the parents of tiny tots on
              31 May. Organised with an intent to familiarise the parents with
              the curriculum and the assessment pattern for the new academic
              year, these sessions saw the active participation of parents on
              the online platform. The sessions set the tone for the forthcoming
              academic year and infused everyone with excitement, energy and
              vigour
            </Typography>
            <Typography align="justify" paragraph>
              The new faculty was formally inducted through a series of Teacher
              Induction Sessions which were interactive, informative and
              thoughtfully curated to meet the demands of the pedagogy of
              current times. They were enriching in terms of educational update,
              transformation and upholding the value system of the institution
            </Typography>
          </Box>
        </Box>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid item container justifyContent={'center'} xs={12} md={6}>
              <Box height={1} width={1} maxWidth={500}>
                <Box
                  component={'img'}
                  src={
                    'https://www.npsypr.com/gallery/gallery/1.%20Artwork%20Jpeg.jpg'
                  }
                  width={1}
                  height={1}
                  sx={{
                    filter:
                      theme.palette.mode === 'dark'
                        ? 'brightness(0.8)'
                        : 'none',
                  }}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
      </Box>
    </Page>
  );
};

export default General;
